var map = {
	"./1.jpg": 233,
	"./2.jpg": 9943,
	"./3.jpg": 3347,
	"./4.jpg": 8508,
	"./6.jpg": 4449,
	"./7.jpg": 4366,
	"./8.jpg": 1257,
	"./9.jpg": 8489,
	"assets/photo/reportage/polish-village/1.jpg": 233,
	"assets/photo/reportage/polish-village/2.jpg": 9943,
	"assets/photo/reportage/polish-village/3.jpg": 3347,
	"assets/photo/reportage/polish-village/4.jpg": 8508,
	"assets/photo/reportage/polish-village/6.jpg": 4449,
	"assets/photo/reportage/polish-village/7.jpg": 4366,
	"assets/photo/reportage/polish-village/8.jpg": 1257,
	"assets/photo/reportage/polish-village/9.jpg": 8489
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2743;